import moment from 'moment';

const buildQueryParams = ({
  country,
  state,
  city,
  gender,
  dateRange,
  verification,
  activeVerificationTab,
  action,
  page,
  limit,
  skip,
  isBot,
  searchTerm,
  sortBy,
  sortOrder,
  duration,
  unRead, isIdVerification, isSelfieVerification,
  profileCompilation,
  filterType,
  requestType,
  statsType,
  utm_payload,
  utmId,
  countries,
  platforms,
  paymentUserFilter,
  funnelType,
  isIosUser,
  source,
  // Channel-attribution node params (only forwarded when source === 'attribution')
  channel,
  campaign,
  adset,
  creative,
  platform,
  from,
  to,
  status,
}) => {
  let queryParams = '';

  if (funnelType) {
    queryParams += `funnelType=${funnelType}&`;
  }

  if (Array.isArray(countries) && countries.length) {
    queryParams += `countries=${encodeURIComponent(countries.join(','))}&`;
  }
  if (Array.isArray(platforms) && platforms.length) {
    queryParams += `platforms=${encodeURIComponent(platforms.join(','))}&`;
  }
  if (Array.isArray(paymentUserFilter) && paymentUserFilter.length) {
    queryParams += `paymentUserFilter=${encodeURIComponent(paymentUserFilter.join(','))}&`;
  }

  if (utmId) {
    queryParams += `utmId=${utmId}&`;
  }
  // `country` arrives in two shapes: the CountrySelect option object ({ code, label })
  // that the redux filter holds, and a plain country NAME from a page with its own
  // dropdown (Engagement → All). `.label` on a string is `undefined`, so the second kind
  // of caller shipped a literal `country=undefined` — truthy server-side, matched
  // exactly against `country`, and the list came back empty with no error anywhere.
  //
  // Encoded, too: these are real place names ("Côte d'Ivoire", "Delhi Division"), and an
  // unescaped one is a query string that means something else by the time it is parsed.
  if (country) {
    const countryName = typeof country === 'string' ? country : country.label;
    if (countryName) queryParams += `country=${encodeURIComponent(countryName)}&`;
  }
  if (state) {
    queryParams += `state=${encodeURIComponent(state)}&`;
  }
  if (city) {
    queryParams += `city=${encodeURIComponent(city)}&`;
  }
  if (isIdVerification) {
    queryParams += `isIdVerification=${isIdVerification}&`;
  }
  if (isSelfieVerification) {
    queryParams += `isSelfieVerification=${isSelfieVerification}&`;
  }
  if (gender) {
    queryParams += `gender=${gender}&`;
  }
  if (utm_payload) {
    queryParams += `utm_payload=${JSON.stringify(utm_payload)}&`;
  }
  if (isBot === true || isBot === false) {
    queryParams += `isBot=${isBot}&`;
  }
  if (isIosUser === true || isIosUser === false) {
    queryParams += `isIosUser=${isIosUser}&`;
  }

  if (profileCompilation) {
    queryParams += `profileCompilation=${profileCompilation}&`;
  }

  if (requestType) {
    queryParams += `requestType=${requestType}&`;
  }

  const startDate = dateRange?.startDate ? moment(dateRange.startDate) : null;
  const endDate = dateRange?.endDate ? moment(dateRange.endDate) : null;

  if (startDate && endDate) {
    queryParams += `startDate=${startDate.format(
      'YYYY-MM-DD'
    )}&endDate=${endDate.format('YYYY-MM-DD')}&`;
  }

  if (verification && activeVerificationTab) {
    let statusFilter = '';
    if (activeVerificationTab === 'Total Verification Requests')
      statusFilter = 'All';
    if (activeVerificationTab === 'Approved Requests')
      statusFilter = 'Approved';
    else if (activeVerificationTab === 'Rejected Requests')
      statusFilter = 'Rejected';
    else if (activeVerificationTab === 'Pending Requests')
      statusFilter = 'Pending';
    if (statusFilter !== '') queryParams += `statusFilter=${statusFilter}&`;
  }

  if (action) {
    queryParams += `action=${action}&`;
  }

  if (page) {
    queryParams += `page=${page}&`;
  }

  if (limit) {
    queryParams += `limit=${limit}&`;
  }
  if (duration) {
    queryParams += `duration=${duration}&`;
  }

  if (skip) {
    queryParams += `skip=${skip}&`;
  }

  // if (isBot) {
  //   queryParams += `isBot=${isBot}&`;
  // }

  if (searchTerm) {
    queryParams += `searchTerm=${searchTerm}&`;
  }

  if (sortBy) {
    queryParams += `sortBy=${sortBy}&`;
  }

  if (sortOrder) {
    queryParams += `sortOrder=${sortOrder}&`;
  }

  if (unRead) {
    queryParams += `unRead=${unRead}&`;
  }

  if (filterType) {
    queryParams += `filterType=${filterType}&`;
  }

  if (statsType) {
    queryParams += `statsType=${statsType}&`;
  }

  if (source) {
    queryParams += `source=${source}&`;
  }

  // Attribution drill-through: forward the selected node as query params so the
  // generic getUsers endpoint can build its member-selection predicate. Strictly
  // additive — only active when the caller opts in via source === 'attribution'.
  if (source === 'attribution') {
    if (channel) {
      queryParams += `channel=${encodeURIComponent(channel)}&`;
    }
    if (campaign) {
      queryParams += `campaign=${encodeURIComponent(campaign)}&`;
    }
    if (adset) {
      queryParams += `adset=${encodeURIComponent(adset)}&`;
    }
    if (creative) {
      queryParams += `creative=${encodeURIComponent(creative)}&`;
    }
    if (platform && platform !== 'all') {
      queryParams += `platform=${encodeURIComponent(platform)}&`;
    }
    if (from) {
      queryParams += `from=${encodeURIComponent(from)}&`;
    }
    if (to) {
      queryParams += `to=${encodeURIComponent(to)}&`;
    }
    // Account-status bucket (set when a metric number is clicked). 'signups' is
    // the all-members default, so it's omitted — only specific buckets are sent.
    if (status && status !== 'signups') {
      queryParams += `status=${encodeURIComponent(status)}&`;
    }
  }

  queryParams = queryParams ? queryParams.slice(0, -1) : '';
  return queryParams;
};

export default buildQueryParams;
